module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG41b3376cf7776af17665e9c1402c8518.41b3376c.png";